import { useSyncExternalStore } from "react";
import { aemetJobStore } from "../../model/aemet/aemetJobStore.ts";
import { isRestartable } from "../../model/aemet/aemetRangeMath.ts";

/** Badge count for TopBar's icon — every download still left to fetch, started or not (pending/loading-stations/range/downloading), not jobs already sitting finished/errored until dismissed. */
export function useActiveAemetJobsCount(): number {
  const jobs = useSyncExternalStore(aemetJobStore.subscribe, aemetJobStore.getAllJobs);
  return jobs.filter((j) => !isRestartable(j.phase)).length;
}

export function useAemetJobsCount(): number {
  const jobs = useSyncExternalStore(aemetJobStore.subscribe, aemetJobStore.getAllJobs);
  return jobs.length;
}
